import React, { useContext, useState } from 'react'
import { Text, View } from 'oio-react'
import { PlayGlyphIcon24 } from 'assets/icons'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'

const InitiativeCoverMedia = () => {
   const [streamIsVisible, setStreamVisible] = useState(false)
   const theme = useContext(ThemeContext)

   const { initiative } = useContext(InitiativeHierarchyContext)
   const userIsMember = initiative?.currentUserRelationship?.elements.find(element => (
      element.__typename === 'RelationshipElementRoleParticipant' &&
      element.role.type === 'primary' &&
      element.status === 'active'
   ))

   const userCanPlayStream = userIsMember && initiative.eventIsVirtual &&
      initiative.eventStream?.enabled

   const date = initiative.startDateTimeISO8601
   let month = null
   let day = null
   if (date) {
      const dateObj = new Date(date)
      month = dateObj.toLocaleString('en-us', { month: 'short' })
      day = dateObj.getDate()
   }

   return (
      <>
         {userCanPlayStream && streamIsVisible && (
            <View
               position="relative"
               paddingTop="56.25%"
               backgroundColor="#000">
               <iframe
                  title={initiative.name}
                  width="100%"
                  height="100%"
                  src={initiative.eventStream?.url}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                     position: 'absolute',
                     top: 0,
                     left: 0
                  }}
               />
            </View>
         )}
         {!streamIsVisible && (
            <View
               position="relative"
               display={initiative.coverMedia ? 'block' : 'none'}
               paddingTop="56.25%"
               backgroundColor="#000"
               backgroundSize="cover"
               backgroundPosition="center center"
               backgroundImage={initiative.coverMedia &&
                  `url(${initiative.coverMedia?.file.thumbnailUrlW1600})`
               }>
               {userCanPlayStream && (
                  <View
                     onClick={() => setStreamVisible(true)}
                     display="flex"
                     alignItems="flex-end"
                     position="absolute"
                     bottom="0px"
                     left="0px"
                     right="0px"
                     top="0px"
                     paddingBottom="15px"
                     paddingLeft={theme.tmpSpacing}
                     style={{
                        cursor: 'pointer',
                        background: 'linear-gradient(0deg, rgba(0,0,0,0.7), rgba(0,0,0,0))'
                     }}>
                     <View display="flex" alignItems="center">
                        <View marginTop="5px" marginRight="10px">
                           <PlayGlyphIcon24 color="#fff" />
                        </View>
                        <Text size={theme.tmpBodyTextSize} lineHeight="100%" color="#fff">
                           Play Live Event Stream
                        </Text>
                     </View>
                  </View>
               )}
               {date && (
                  <View
                     borderBottom="1px solid #e5e5e5"
                     flex="0 0 auto"
                     position="absolute"
                     float="left"
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     width="45px"
                     height="45px"
                     top={theme.tmpSpacing}
                     left={theme.tmpSpacing}
                     borderRadius="3px"
                     backgroundColor="#fff"
                     textAlign="center">
                     <div>
                        <Text
                           color="#000"
                           lineHeight="120%"
                           size="0.8"
                           transform="uppercase">
                           {month}
                        </Text>
                        <Text color="#000" lineHeight="110%" weight="medium" size="4">
                           {day}
                        </Text>
                     </div>
                  </View>
               )}
            </View>
         )}
      </>
   )
}

export default InitiativeCoverMedia
